// const baseURL = process.env.REACT_APP_API_BASE_URL;
// export const BASE_URL = `http://localhost:9000/api/v1`;
// export const BASE_URL_FOR_FILE = `http://localhost:9000/uploads`;
// export const URL_BASE = `http://localhost:9000`;
// export const BASE_URL_SOCKET = `http://localhost:8080`;
 
//kakkarsshospital
// export const BASE_URL = 'https://kakkarsshospital.chikitsartha.com:1100/api/v1';
// export const BASE_URL_FOR_FILE = 'https://kakkarsshospital.chikitsartha.com:1100/uploads';
// export const URL_BASE = `https://kakkarsshospital.chikitsartha.com:1100`;
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080';

// kunjpathology 
// export const BASE_URL = 'https://kunjpathology.chikitsartha.com:1200/api/v1';
// export const BASE_URL_FOR_FILE = 'https://kunjpathology.chikitsartha.com:1200/uploads';
// export const URL_BASE = `https://kunjpathology.chikitsartha.com:1200`;
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080';

//jitendrahospital
// export const BASE_URL = 'https://jitendrahospital.sarserp.com:1180/api/v1';
// export const BASE_URL_FOR_FILE = 'https://jitendrahospital.sarserp.com:1180/uploads';
// export const URL_BASE = `https://jitendrahospital.sarserp.com:1180`;
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080';

//queensmedicare
// export const BASE_URL = 'https://queensmedicare.chikitsartha.com:1200/api/v1';
// export const BASE_URL_FOR_FILE = 'https://queensmedicare.chikitsartha.com:1200/uploads';
// export const URL_BASE = `https://queensmedicare.chikitsartha.com:1200`;
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080';

//shrinarayanhearthospital
// export const BASE_URL = 'https://shrinarayanhearthospital.chikitsartha.com:1400/api/v1';
// export const BASE_URL_FOR_FILE = 'https://shrinarayanhearthospital.chikitsartha.com:1400/uploads';
// export const URL_BASE = `https://shrinarayanhearthospital.chikitsartha.com:1400`;
// export const BASE_URL_SOCKET = 'https://shrinarayanhearthospital.chikitsartha.com:1400';

//https://gillhospital.sarserp.com:9005/
// export const BASE_URL = 'https://gillhospital.sarserp.com:9005/api/v1';
// export const BASE_URL_FOR_FILE = 'https://gillhospital.sarserp.com:9005/uploads';
// export const URL_BASE = `https://gillhospital.sarserp.com:9005`;
// export const BASE_URL_SOCKET = 'https://gillhospital.sarserp.com:9005';




//https://duaahospital.chikitsartha.com:1500/

// export const BASE_URL = 'https://duaahospital.chikitsartha.com:1500/api/v1';
// export const BASE_URL_FOR_FILE = 'https://duaahospital.chikitsartha.com:1500/uploads';
// export const URL_BASE = `https://duaahospital.chikitsartha.com:1500`;
// export const BASE_URL_SOCKET = 'https://duaahospital.chikitsartha.com:1500';

//https://demo.chikitsartha.com:1300/

export const BASE_URL = 'https://demo.chikitsartha.com:1300/api/v1';
export const BASE_URL_FOR_FILE = 'https://demo.chikitsartha.com:1300/uploads';
export const URL_BASE = `https://demo.chikitsartha.com:1300`;
export const BASE_URL_SOCKET = 'https://demo.chikitsartha.com:1300';